import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const updateAuthoringLegislation = api(async function updateAuthoringLegislation({ id, legislation }) {
    return mutate(
        gql`
            mutation UpdateAuthoringLegislation($id: String!, $legislation: AuthoringLegislationInput!) {
                updateAuthoringLegislation(id: $id, legislation: $legislation) {
                    id
                    legacyId
                    title
                    redirectUrl
                    url
                    description
                    scheduleCount
                    scheduleIds
                    lastModified
                }
            }
        `,
        { id, legislation },
        { returns: "updateAuthoringLegislation" }
    )
})
